import React from 'react'
import isRecurring from '../helpers/contractPlans/isRecurring'

const useRecurringCheck = () => {
  const [quantityChecked, setQuantityChecked] = React.useState({})

  const handleChangeCheck = (event, fieldName, setValue, defaultValue) => {
    if (event.target.checked) {
      setValue(fieldName, '0', true)

      setQuantityChecked(prevState => ({
        ...prevState,
        [fieldName]: true,
      }))
    } else {
      setValue(fieldName, defaultValue || '', true)

      setQuantityChecked(prevState => ({
        ...prevState,
        [fieldName]: false,
      }))
    }
  }

  const handleChangeQuantity = (event, fieldName) => {
    if (event.target.value === '0') {
      setQuantityChecked(prevState => ({
        ...prevState,
        [fieldName]: true,
      }))
    } else {
      setQuantityChecked(prevState => ({
        ...prevState,
        [fieldName]: false,
      }))
    }
  }

  const checkRecurrentValue = (fieldName, fieldValue) => {
    return quantityChecked[fieldName] !== undefined
      ? quantityChecked[fieldName]
      : isRecurring(fieldValue)
  }

  return {
    quantityChecked,
    setQuantityChecked,
    handleChangeCheck,
    handleChangeQuantity,
    checkRecurrentValue,
  }
}

export default useRecurringCheck
